var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 82,
    viewBox: "0 0 81 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 41.25C81 61.7124 66.1702 78.6762 46.8112 81.7546V53.181H56.2241L58.0163 41.3593H46.8112V33.6889C46.8112 30.4533 48.3773 27.3032 53.3925 27.3032H58.4854V17.2377C58.4854 17.2377 53.8616 16.4382 49.4437 16.4382C40.2165 16.4382 34.1888 22.0996 34.1888 32.3462V41.3559H23.9321V53.1776H34.1888V81.7512C14.8331 78.6693 0 61.709 0 41.25C0 18.6078 18.1339 0.25 40.5 0.25C62.8661 0.25 81 18.6043 81 41.25Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.b3df9c86da8cad43c8172cd7092293a9.svg";
export { ForwardRef as ReactComponent };